import type { FigmaImportReport } from './convert';

/**
 * The downloadable import report (backlog §12): counts by type, images, every node left out or approximated with its
 * reason, and the authorship rule. `t` is the app's translator (keys under `figmaImport.report`).
 */
export function reportText(r: FigmaImportReport, t: (key: string, v?: object) => string, name: string): string {
  const lines = [t('figmaImport.report.title', { name }), '', t('figmaImport.report.pages', { count: r.pages })];
  for (const [type, count] of Object.entries(r.imported)) if (count) lines.push(t('figmaImport.report.type', { type: t(`a11y.types.${type}`), count }));
  lines.push(t('figmaImport.report.images', { count: r.images.total, missing: r.images.withoutUrl }), '');
  const left = r.ignored.filter((i) => i.reason !== 'approximate');
  const byType = new Map<string, number>();
  for (const i of left) byType.set(i.type, (byType.get(i.type) ?? 0) + 1);
  lines.push(t('figmaImport.report.ignored', { count: left.length }));
  for (const [type, count] of byType) lines.push(t('figmaImport.report.ignoredByType', { type, count }));
  for (const i of r.ignored) lines.push(`- ${i.type} "${i.name}" (${i.id}): ${t(`figmaImport.report.reasons.${i.reason}`)}`);
  lines.push('', t('figmaImport.report.author'));
  return `${lines.join('\n')}\n`;
}
